/* src/app/components/case/uploads/native-upload-batch-report/native-upload-batch-report.component.scss */
mat-card-title {
  font-size: 24px;
  font-weight: 500;
}
.fa-file-excel {
  color: #303F9F;
}
.fa-traffic-cone {
  color: #303F9F;
}
:host-context(.dark-theme) .fa-file-excel {
  color: #88a3ff;
}
:host-context(.dark-theme) .fa-traffic-cone {
  color: #88a3ff;
}
:host-context(.dark-theme) ngx-charts-number-card.info-card ::ng-deep .card {
  fill: #C5CAE9 !important;
}
:host-context(.dark-theme) ngx-charts-number-card.info-card ::ng-deep .card-band {
  fill: #5C6BC0 !important;
}
:host-context(.dark-theme) ngx-charts-number-card.warning-card ::ng-deep .card {
  fill: #FFE0B2 !important;
}
:host-context(.dark-theme) ngx-charts-number-card.warning-card ::ng-deep .card-band {
  fill: #FFA726 !important;
}
:host-context(.dark-theme) ngx-charts-number-card.error-card ::ng-deep .card {
  fill: #F8BBD0 !important;
}
:host-context(.dark-theme) ngx-charts-number-card.error-card ::ng-deep .card-band {
  fill: #EC407A !important;
}
/*# sourceMappingURL=native-upload-batch-report.component.css.map */
